<template>
  <!-- 移动端 -->
  <div v-if="data.temporaryPageEnd.menuList.length>0" class="tabBars">
    <div class="tab-bar-item"
         v-for="(item,index) in data.temporaryPageEnd.menuList" :key="index"
         v-show="item.menuDisplay && ((item.isLogin == 1 &&token) || item.isLogin == 2)"
         @click="selectItem(item)">
      <img v-if="!item.isActive" :src='item.defaultIcon'>
      <img v-if="item.isActive" :src='item.selectIcon'>
      <span v-if="item.isActive" class="selectText">{{ item.name }}</span>
      <span v-if="!item.isActive" class="defText">{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    dataS:{
      type:Object,
      default: () => ({})
    }
  },
  data() {
    return {
      token:localStorage.getItem('token')?localStorage.getItem('token'):'',
      data: {
        isH5: false, // 是否是h5
        temporaryPageEnd: {
          token: '',
          selectId:'', // 选中的tabBar样式
          menuList: []
        },
      }
    }
  },
  mounted() {
    console.log(8888888888);
    // 初始化选中第一个
    this.data.temporaryPageEnd = this.dataS;
    console.log(this.dataS,'this.dataSthis.dataSthis.dataS')
    // if(sessionStorage.getItem('selectMenuId')){
    //   console.log(6666666666666,this.$route.path,sessionStorage.getItem('selectMenuId'));
    //   let temArr = [];
    //   this.data.temporaryPageEnd.menuList.forEach((items, index) => {
    //     if (sessionStorage.getItem('selectMenuId') == items.id) {
    //       items.isActive = true;
    //     } else {
    //       items.isActive = false;
    //     }
    //     temArr.push(items)
    //   })
    //   this.data.temporaryPageEnd.menuList = temArr;
    // }else {
    //   console.log(222222222222222222222,this.$route.path,sessionStorage.getItem('selectMenuId'));
    //     let temArr = [];
    //     this.data.temporaryPageEnd.menuList.forEach((items, index) => {
    //       if (this.$route.path == items.url) {
    //         sessionStorage.setItem('selectMenuId',items.id)
    //         items.isActive = true;
    //       } else {
    //         items.isActive = false;
    //       }
    //       temArr.push(items)
    //     })
    //     this.data.temporaryPageEnd.menuList = temArr;
    // }
    let temArr = [];
      this.data.temporaryPageEnd.menuList.forEach((items, index) => {
        if (this.$route.path == items.url) {
          sessionStorage.setItem('selectMenuId',items.id)
          items.isActive = true;
        } else {
          items.isActive = false;
        }
        temArr.push(items)
      })
      this.data.temporaryPageEnd.menuList = temArr;
  },
  methods: {


    // tokenChange(){
    //   this.$forceUpdate();
    // },

    // 选中item
    selectItem(item) {
      let temArr = [];
      this.data.temporaryPageEnd.menuList.forEach((items, index) => {
        if (item.id == items.id) {
          sessionStorage.setItem('selectMenuId', item.id);
          items.isActive = true;
        } else {
          items.isActive = false;
        }
        temArr.push(items)
      })
      this.data.temporaryPageEnd.menuList = temArr;
      //跳转逻辑判断
      this.pushPage(item)
    },

    // 跳转逻辑判断
    pushPage(item) {
      if (!item.url) {
        return
      }
      if (item.menuLocation == 4) {
        item.openMode == 1 ? window.location.href = item.url : window.open(item.url, '_blank');
      } else {
        this.$router.push({
          path:item.url,
        })
      }

    }
  }
}
</script>
<style lang="stylus" scoped>
.tabBars {
  background-color: #fff;
  width: 100%;
  display: flex;
  height: 100px;
  .tab-bar-item {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 46px;
      height: 44px;
    }

    .selectText {
      margin-top: 10px;
      height: 20px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3760FF;
      line-height: 20px;
    }

    .defText {
      margin-top: 10px;
      height: 20px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }
  }
}
</style>
